import { useCallback } from 'react';

import { setIn } from '@lyearn/core/utils/immutable';
import { QuizOptionsActionEnum } from '@/modules/corporate/modules/questions/fields/hooks/useOptionsAction/actions';

import { UseEditorOptionsListItemProps } from './types';

const useEditorOptionsListItem = ({ onAction, index, option }: UseEditorOptionsListItemProps) => {
  const onChangeText = (optionText: string) => {
    onAction({
      type: QuizOptionsActionEnum.UpdateOption,
      payload: { index, option: setIn(option, 'optionText', optionText) },
    });
  };

  const onChangeWeight = (optionRelativeScore: number) => {
    const optionWithWeight = setIn(option, 'optionRelativeScore', optionRelativeScore);
    onAction({
      type: QuizOptionsActionEnum.UpdateOption,
      payload: {
        index,
        option: setIn(optionWithWeight, 'optionEvaluation', optionRelativeScore > 0),
      },
    });
  };

  const onRemove = useCallback(() => {
    onAction({ type: QuizOptionsActionEnum.RemoveOption, payload: { index } });
  }, [index, onAction]);

  const onToggleEvaluation = useCallback(
    (_: any, optionEvaluation: boolean) => {
      onAction({
        type: QuizOptionsActionEnum.SetOptionEvaluation,
        payload: { index, optionEvaluation },
      });
    },
    [index, onAction],
  );

  return { onChangeText, onChangeWeight, onRemove, onToggleEvaluation };
};

export default useEditorOptionsListItem;
